module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-card ownership-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_c('span', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.data.percentage))]), _vm._v(" "), _c('span', {
    staticClass: "percentage-symbol"
  }, [_vm._v("%")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-description"
  }, [_vm._v("\n    You hold the Buy Box on "), _c('strong', [_vm._v(_vm._s(_vm.data.owned) + " of " + _vm._s(_vm.data.total))]), _vm._v(" tracked products.\n  ")]), _vm._v(" "), (_vm.data.trendText) ? _c('div', {
    staticClass: "stat-trend"
  }, [_c('span', {
    staticClass: "trend-badge",
    class: {
      negative: _vm.data.trend < 0,
      positive: _vm.data.trend > 0
    }
  }, [(_vm.data.trend < 0) ? _c('i', {
    staticClass: "chart line icon"
  }) : (_vm.data.trend > 0) ? _c('i', {
    staticClass: "chart line icon"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.data.trendText) + "\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-header"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("BUY BOX OWNERSHIP")]), _vm._v(" "), _c('i', {
    staticClass: "info circle icon",
    attrs: {
      "title": "Buy Box ownership percentage across tracked products"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71762a82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/BuyBoxOwnershipCard.vue
// module id = 792
// module chunks = 2